// The deploy environment: testing, staging, production, or development for
// the dev server. Deployed builds set NODE_ENV to production so libraries
// ship their production code, so environment checks read APP_ENV instead.
// Change this fallback -> change the copy in Config.js (a CommonJS file).
export const currentAppEnv = () => process.env.APP_ENV || process.env.NODE_ENV;
export const APP_ENV = currentAppEnv();
